import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M67.9701 1.29993H1.80005L4.28006 22.77C4.28006 22.77 2.79005 37.47 14.5201 40.11C14.5201 40.11 14.0201 37.47 16.5001 34.83C18.9801 32.19 17.6601 29.71 17.6601 29.71C17.6601 29.71 20.3001 33.1799 18.9801 36.8099C18.9801 36.8099 22.7801 37.1399 24.2601 32.6799C24.2601 32.6799 26.4101 40.4399 33.1801 40.2799H36.5901C43.3601 40.4499 45.5101 32.6799 45.5101 32.6799C47.0001 37.1399 50.7901 36.8099 50.7901 36.8099C49.4701 33.1799 52.11 29.71 52.11 29.71C52.11 29.71 50.7901 32.19 53.2701 34.83C55.75 37.47 55.2501 40.11 55.2501 40.11C66.9701 37.47 65.4901 22.77 65.4901 22.77L67.9701 1.29993Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </g>
  )
}
